<template>
  <div id="WorkBench">
    <h1>Work Bench for {{component_name}}</h1>
    <hr/>
    <component v-bind:is="component_name"  />
  </div>
</template>

<script>
    /*
    Test individual components by mounting them dynamically:
      https://localhost:8080/components/HelloWorld
      https://localhost:8080/views/BotEditor
     */
    import InputBar from "../components/InputBar";
    import HelloWorld from "../components/HelloWorld";
    export default {
        name: "WorkBench",
        props: ['something'],
        components: {InputBar, HelloWorld},
        data() {
            return {
                component_path: '',
                component_name: '',
                error_messages: []
            }
        },
        mounted() {
            this.component_name = this.$route.params.component_name || 'Name not found in params';
            this.component_path = this.$route.params.component_path || 'Path not found in params';
        }
    }
</script>

<style scoped>

</style>
